const urlProduccion = 'https://apisolidare-11b0715ba540.herokuapp.com/api/';
// const urlProduccion = 'http://localhost:8000/api/';
export default urlProduccion;